const BASE_FILE = 'https://www.visualcomfortasia.com/dmz/base/file'
const BASE_ACL = 'https://www.visualcomfortasia.com/dmz/base/acl'
const EC_BASE_ACL = 'https://www.visualcomfortasia.com/ec/base/acl'
const EC_BASE_INFO = 'https://www.visualcomfortasia.com/ec/base/info'
const DMZ_BASE_INFO = 'https://www.visualcomfortasia.com/dmz/base/info'
const CMC_BASE = 'https://www.visualcomfortasia.com/dmz/cmc/base'
const CMS_DICT = 'https://www.visualcomfortasia.com/dmz/cms/dict'
const CMS_CART = 'https://www.visualcomfortasia.com/ec/cms/web/cart'
const CMS_FAVORITES = 'https://www.visualcomfortasia.com/ec/cms/web/favorites'
const DMZ_PMC = 'https://www.visualcomfortasia.com/dmz/pmc'
const PMC_DESIGNER = 'https://www.visualcomfortasia.com/dmz/pmc/info/designer'
const MSI_BASE = 'https://www.visualcomfortasia.com/dmz/base'
const IMS_ORDER = 'https://www.visualcomfortasia.com/ec/ims/order'
const DMZ_MMC_MEMBER = 'https://www.visualcomfortasia.com/dmz/mmc/info/member'
const EC_MMC_MEMBER = 'https://www.visualcomfortasia.com/ec/mmc/info/member'
const MMC_MEMBERADDRESS = 'https://www.visualcomfortasia.com/ec/mmc/info/memberAddress'
const CMS_CASE = 'https://www.visualcomfortasia.com/dmz/cms/web/case'
const CMS_CASETYP = 'https://www.visualcomfortasia.com/dmz/cms/web/caseType'
const CMS_PROJECT = 'https://www.visualcomfortasia.com/ec/cms/web/project'
const CMS_TIPS = 'https://www.visualcomfortasia.com/dmz/cms/web/tips'
const CMS_WY = 'https://www.visualcomfortasia.com/dmz/cms/web'
const MSI_MIS = 'https://www.visualcomfortasia.com/ec/ims/after'
const FINANCE_PAY = 'https://www.visualcomfortasia.com/ec/ims/finance/receipt'
const ACCOUNT = 'https://www.visualcomfortasia.com/ec/ims/info/account'
const BASE_PAY = 'https://www.visualcomfortasia.com/ec/wechat/finance/pay'
const MMC_GIFT = 'https://www.visualcomfortasia.com/ec/mmc/exchange/gift'
const MMC_EXCHANGE = 'https://www.visualcomfortasia.com/ec/mmc/exchange'
const IMS_PAY = 'https://www.visualcomfortasia.com/ec/ims/finance/pay'
const IMS_PRODUCT = 'https://www.visualcomfortasia.com/dmz/pmc/info/product'
const MSI_PPRODUCT = 'https://www.visualcomfortasia.com/dmz/pmc/info'
const MMC_POINTS = 'https://www.visualcomfortasia.com/ec/mmc/points'
const IMS_FINANCE = 'https://www.visualcomfortasia.com/ec/ims/finance'
const MCC_CAPAIGN = 'https://www.visualcomfortasia.com/ec/mcc/campaign'
const CMC_DEALER = 'https://www.visualcomfortasia.com/ec/cmc/base/dealer'
const CMC_DEARADDRESS = 'https://www.visualcomfortasia.com/ec/cmc/base/dearAddress'
const EC_INFO = 'https://www.visualcomfortasia.com/ec/pmc/info'
const IMS_STOCK = 'https://www.visualcomfortasia.com/ec/ims/stock'
const CMS_WEB = 'https://www.visualcomfortasia.com/ec/cms/web'
const IMS_PROJECT = 'https://www.visualcomfortasia.com/ec/ims/order/project'
const EC_BASE_FILE = 'https://www.visualcomfortasia.com/ec/base/file'

//网页管理
const DATA_DICT = { // 数据字典
}
export default {
    EC_INFO,
    BASE_FILE,
    MCC_CAPAIGN,
    BASE_ACL,
    CMS_DICT,
    DMZ_PMC,
    CMS_CART,
    CMS_FAVORITES,
    MSI_BASE,
    IMS_ORDER,
    DMZ_MMC_MEMBER,
    EC_MMC_MEMBER,
    MMC_MEMBERADDRESS,
    CMS_PROJECT,
    PMC_DESIGNER,
    EC_BASE_ACL,
    EC_BASE_INFO,
    CMS_CASE,
    CMS_TIPS,
    DATA_DICT,
    CMC_BASE,
    CMS_WY,
    MSI_MIS,
    ACCOUNT,
    FINANCE_PAY,
    CMS_CASETYP,
    BASE_PAY,
    MMC_GIFT,
    IMS_PAY,
    MSI_PPRODUCT,
    IMS_PRODUCT,
    MMC_EXCHANGE,
    MMC_POINTS,
    IMS_FINANCE,
    CMC_DEALER,
    CMC_DEARADDRESS,
    DMZ_BASE_INFO,
    IMS_STOCK,
    CMS_WEB,
    IMS_PROJECT,
    EC_BASE_FILE
}



// WEBPACK FOOTER //
// ./src/constants/Global.constants.js